type Offset = { x: number; y: number }
type Bounds = { left: number; top: number; right: number; bottom: number }

/** Space kept between the popover and each live-area edge. */
const EDGE_MARGIN = 8

/**
 * Clamps a drag offset so the popover stays inside the live area, 8px from each edge. `anchor` is
 * the popover's rect at offset 0 (where Radix placed it beside the rail). That spot can sit over the
 * left panel, outside the live area, so it stays reachable instead of snapping away on the first move.
 */
export function clampPopoverOffset(desired: Offset, anchor: DOMRect, bounds: Bounds): Offset {
  const minLeft = Math.min(bounds.left + EDGE_MARGIN, anchor.left)
  const minTop = Math.min(bounds.top + EDGE_MARGIN, anchor.top)
  const maxLeft = Math.max(minLeft, bounds.right - anchor.width - EDGE_MARGIN)
  const maxTop = Math.max(minTop, bounds.bottom - anchor.height - EDGE_MARGIN)

  const left = Math.max(minLeft, Math.min(maxLeft, anchor.left + desired.x))
  const top = Math.max(minTop, Math.min(maxTop, anchor.top + desired.y))

  return { x: left - anchor.left, y: top - anchor.top }
}
